import Axios from "axios";

export default {
    busquedaEstadistica(vm, datos) {
        var formData = new FormData();
        formData.append("fechaini", datos.fechaini);
        formData.append("fechafin", datos.fechafin);
        formData.append("estado", datos.estado.esclave);

        return vm.axios.post(`${vm.domain.domainNameForApi}Estadistica/BusquedaEstadistica`, formData).then(response => response.data)
    },

    ListadoReportes(vm, datos) {
        var formData = new FormData();
        formData.append("fechaini", datos.FechaIni);
        formData.append("fechafin", datos.FechaFin);
        formData.append("estado", datos.Estado);
        formData.append("tipo", datos.Tipo);
        return vm.axios.post(`${vm.domain.domainNameForApi}Estadistica/ListadoReportes`, formData).then(response => response.data)
    },
}